import { hasPermission } from '@/utils/helper/permissionHelper'

/**
 * 按钮权限
 */
export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    if (hasPermission(value)) {
      return true
    } else {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
